export enum TicketType {
    idea = 'idea',
    problem = 'problem'
}
